define(["exports", "@babel/runtime/helpers/esm/extends", "react", "styled-components", "react-intl-universal", "../../atoms", "../../themes", "./CommentMsg", "./CommentForm"], function (_exports, _extends2, _react, _styledComponents, _reactIntlUniversal, _atoms, _themes, _CommentMsg, _CommentForm) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _CommentMsg = _interopRequireDefault(_CommentMsg);
  _CommentForm = _interopRequireDefault(_CommentForm);

  var ContainerDiv = _styledComponents.default.div.withConfig({
    displayName: "Comments__ContainerDiv",
    componentId: "sc-18fvflx-0"
  })(["display:flex;box-icon{background:", ";border-radius:50%;fill:", ";left:10px;margin-top:16px;padding:2px;position:relative;top:-10px;&:after{background:", ";content:'';display:block;height:20px;left:10px;position:absolute;top:24px;width:4px;}}> button{", ";color:", ";font-size:1.4em;font-weight:", ";height:40px;line-height:40px;margin-left:36px;&:disabled{cursor:not-allowed;opacity:0.5;}}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.orange;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.white;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.lightGray;
  }, _themes.resetButton, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.orange;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.font.semibold;
  });

  var CommentsContainer = _styledComponents.default.div.withConfig({
    displayName: "Comments__CommentsContainer",
    componentId: "sc-18fvflx-1"
  })(["min-width:700px;padding:24px;"]);

  var LoarderContent = _styledComponents.default.div.withConfig({
    displayName: "Comments__LoarderContent",
    componentId: "sc-18fvflx-2"
  })(["left:2px;position:relative;top:2px;"]);

  var ErrorText = _styledComponents.default.div.withConfig({
    displayName: "Comments__ErrorText",
    componentId: "sc-18fvflx-3"
  })(["color:", ";font-size:1.6em;line-height:14px;margin:8px 50px;padding:2px 8px;> box-icon{fill:", ";height:16px;margin-right:8px;position:relative;top:3px;width:16px;}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.red;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.red;
  });

  var CommentList = _styledComponents.default.ul.withConfig({
    displayName: "Comments__CommentList",
    componentId: "sc-18fvflx-4"
  })(["margin:auto;max-height:410px;padding:0;overflow-y:auto;"]);

  var Comments = function Comments(_ref8) {
    var _getCommentsState$dat4, _getCommentsState$dat5;

    var getComments = _ref8.getComments,
        getCommentsState = _ref8.getCommentsState,
        postComment = _ref8.postComment,
        postCommentState = _ref8.postCommentState,
        user = _ref8.user,
        placeholderForm = _ref8.placeholderForm,
        subtitleContainer = _ref8.subtitleContainer,
        maxChar = _ref8.maxChar,
        minChar = _ref8.minChar,
        commentText = _ref8.commentText,
        setCommentText = _ref8.setCommentText;

    var _useState = (0, _react.useState)([]),
        comments = _useState[0],
        setComments = _useState[1];

    var _useState2 = (0, _react.useState)(''),
        errorMsg = _useState2[0],
        setErrorMsg = _useState2[1];

    var _useState3 = (0, _react.useState)(0),
        currentPage = _useState3[0],
        setCurrentPage = _useState3[1];

    var _useState4 = (0, _react.useState)(0),
        pages = _useState4[0],
        setPages = _useState4[1];

    (0, _react.useEffect)(function () {
      if ((getCommentsState == null ? void 0 : getCommentsState.status) === 'fulfilled') {
        var _getCommentsState$dat, _getCommentsState$dat2;

        setCurrentPage(getCommentsState == null ? void 0 : (_getCommentsState$dat = getCommentsState.data) == null ? void 0 : _getCommentsState$dat.pagina);
        setPages(getCommentsState == null ? void 0 : (_getCommentsState$dat2 = getCommentsState.data) == null ? void 0 : _getCommentsState$dat2.total_paginas);
        setComments(function (prev) {
          var _getCommentsState$dat3;

          return [].concat(getCommentsState == null ? void 0 : (_getCommentsState$dat3 = getCommentsState.data) == null ? void 0 : _getCommentsState$dat3.items, prev);
        });
      }

      if ((getCommentsState == null ? void 0 : getCommentsState.status) === 'rejected') {
        setErrorMsg(_reactIntlUniversal.default.getHTML('COMENTARIOS.ER_CARREGAR_COMENTARIO'));
      }
    }, [getCommentsState]);
    (0, _react.useEffect)(function () {
      if ((postCommentState == null ? void 0 : postCommentState.status) === 'fulfilled') {
        setComments(function (prev) {
          return [].concat(prev, [postCommentState == null ? void 0 : postCommentState.data]);
        });
      }
    }, [postCommentState]);
    return /*#__PURE__*/_react.default.createElement(CommentsContainer, null, /*#__PURE__*/_react.default.createElement(_atoms.H1, null, _reactIntlUniversal.default.get('COMENTARIOS.TITULO')), (getCommentsState == null ? void 0 : (_getCommentsState$dat4 = getCommentsState.data) == null ? void 0 : (_getCommentsState$dat5 = _getCommentsState$dat4.items) == null ? void 0 : _getCommentsState$dat5.length) === 0 ? /*#__PURE__*/_react.default.createElement(_atoms.H3, null, _reactIntlUniversal.default.get('COMENTARIOS.SEM_COMENTARIOS')) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.H3, null, subtitleContainer || _reactIntlUniversal.default.get('COMENTARIOS.SUBTITULO')), /*#__PURE__*/_react.default.createElement(ContainerDiv, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "time-five",
      type: "solid"
    }), /*#__PURE__*/_react.default.createElement("button", {
      onClick: function onClick() {
        return getComments();
      },
      disabled: currentPage === pages || (getCommentsState == null ? void 0 : getCommentsState.status) === 'pending'
    }, currentPage < pages ? _reactIntlUniversal.default.get('COMENTARIOS.CARREGAR_MAIS') : _reactIntlUniversal.default.get('COMENTARIOS.CARREGADOS')))), (getCommentsState == null ? void 0 : getCommentsState.status) === 'pending' && /*#__PURE__*/_react.default.createElement(LoarderContent, null, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "436",
      height: "116",
      viewBox: "0 0 436 116",
      fill: "none"
    }, /*#__PURE__*/_react.default.createElement("rect", {
      x: "18",
      width: "4",
      height: "116",
      rx: "2",
      fill: "#E6E6E6"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "56",
      y: "40",
      width: "111",
      height: "8",
      rx: "2",
      fill: "#E6E6E6"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "56",
      y: "64",
      width: "380",
      height: "8",
      rx: "2",
      fill: "#E6E6E6"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "56",
      y: "80",
      width: "276",
      height: "8",
      rx: "2",
      fill: "#E6E6E6"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      cx: "20",
      cy: "44",
      r: "20",
      fill: "#E6E6E6"
    }))), errorMsg && /*#__PURE__*/_react.default.createElement(ErrorText, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "x-circle",
      type: "solid"
    }), errorMsg), /*#__PURE__*/_react.default.createElement(CommentList, null, comments.map(function (item) {
      return /*#__PURE__*/_react.default.createElement(_CommentMsg.default, {
        message: item,
        key: item.data_criacao
      });
    })), /*#__PURE__*/_react.default.createElement(_CommentForm.default, (0, _extends2.default)({
      postComment: postComment,
      postCommentState: postCommentState,
      user: user,
      placeholderForm: placeholderForm || _reactIntlUniversal.default.get('COMENTARIOS.FORM.PLACEHOLDER')
    }, maxChar, minChar, {
      commentText: commentText,
      setCommentText: setCommentText
    })));
  };

  var _default = Comments;
  _exports.default = _default;
});